import React from 'react';
import { connect } from 'react-redux';
import { List } from 'immutable';
import {
  Col,
  Row,
  Button,
} from 'react-bootstrap';
import {
  FormControl,
  DateTimePicker2 as DateTimePicker,
} from '../../../../form/FormControls.jsx';
import { FormTextField } from '../../elements/FormTextField';
import RequiredFormControl from '../../../../form/RequiredFormControl.jsx';
import momentLocalizer from 'react-widgets-moment';
import moment from 'moment';
import { creationTimeTooltip } from '@/util/util';
moment.locale('en');
momentLocalizer();
import { usdDefaultCurrencyRates } from '@/util/util.jsx';
import { dateTimePickerFormat } from '../../../../../util/util.jsx';
import { railcarLoadingStatus } from '../../../../dict/Enums.js';
import Label from '@/component/form/Label.jsx';
import CurrencyInput from '@/component/form/currencyinput/index.jsx';
import RefPicker from '../../../../dict/simple/select/DictPicker.jsx';
import UserPicker from '@/component/managment/users/Select.jsx';
import ProductsViewer from '../ProductsViewer.jsx';
import TransportElement from '../../elements/TransportElement.jsx';
import { handleFormChanged } from '@/store/allaround.store.js';
import { updateDealField, updateDealFields,
  alterPortField, alterVesselname } from '../../store/deal.store';
import AbstractTransportEdit from '../AbstractTransportEdit';
import loadport from '../../../../../../style/loadportblue.png';
import unloadport from '../../../../../../style/unloadportblue.png';

class TruckEdit extends AbstractTransportEdit {
  render() {
    return (
      <div>
        <input
          name="transportType" defaultValue="TRUCK" style={{ display: 'none' }}
        />

        <Col md={12}className={'dealsEditTopPanel'}>
          <Row>
            <Col md={6}>
              <Row>
                <Col md={3}>
                  <Label
                    label="Creator" vertical sm={12}

                  >
                    {creationTimeTooltip(this.props.data, <UserPicker
                      name="creator"
                      defaultValue={this.props.isNew ? this.props.currentUser :
                        this.props.data.get('creator')}
                      disabled
                    />)}
                  </Label>

                </Col>
                <Col md={6}>
                  <Label
                    label="Chartering responsible"
                    vertical
                    sm={12}

                  >
                    <UserPicker
                      name="responsibles" multi
                      defaultValue={this.props.isNew ? this.props.currentUser
                        : this.props.data.get('responsibles')}
                      disabled={this.props.locked || !this.props.allowResponsiblesEdit}
                    />
                  </Label>
                </Col>
                <Col md={3}>
                  <Label label="Forwarder" vertical sm={12} >
                    <RefPicker
                      dict="forwarder" name="forwarder"
                      defaultValue={this.props.data.get('forwarder')}
                      onChangeFunc={v => this.props.updateDealField('forwarder', v.value)}
                      disabled={this.props.disabled}
                    />
                  </Label>
                </Col>
              </Row>
            </Col>
            <Col md={2}>
              <Label
                label="Free demurrage" vertical sm={12}

              >
                <FormControl
                  name="freeDemurrage"
                  defaultValue={this.props.data.get('freeDemurrage')}
                  disabled={this.props.disabled}
                />
              </Label>
            </Col>
            <Col md={2}>
              <Label label="Freight" vertical sm={12} >
                <Row id="freightCurrency">
                  <Col sm={4}>
                    <CurrencyInput
                      name="freightCurrency"
                      defaultValue={this.props.data.get('freightCurrency')}
                      defaultValueRates={usdDefaultCurrencyRates(
                        this.props.data.get('freightCurrencyRates'))}
                      onChange={this.onChangeFreightCurrency}
                      disabled={this.props.disabled}
                    />
                  </Col>
                  <Col sm={8}>
                    {this.freightInput()}
                  </Col>
                </Row>
              </Label>
            </Col>
            <Col md={2} className="transport-buttons" >
              <Button
                bsSize="xsmall"
                bsStyle={this.props.data.get('isArchived') ? 'primary' : 'gray'}

                id="isArchived"
                disabled={this.props.disabled || !(this.props.data.get('id')
                || this.props.data.get('id') == 0)}
                onClick={this.props.onArchive}
                title="Archive"
              >
                Archive
              </Button>
              <Button
                bsSize="xsmall"
                bsStyle={this.props.data.get('hasDispute') ? 'primary' : 'gray'}
                id="isArchived"
                disabled={this.props.disabled}
                onClick={() => {
                  this.props.updateDealField('hasDispute', !this.props.data.get('hasDispute'));
                  this.props.handleFormChanged();
                }
                }
                title="Dispute"
              >
                Dispute
              </Button>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Label label="Truck name" vertical sm={12} >
                <FormControl
                  name="vesselName"
                  defaultValue={this.props.data.get('vesselName')}
                  onChange={this.onContractNumberChange}
                  disabled={this.props.disabled}
                />
              </Label>
            </Col>
            <Col md={6}>
              <Label label="Product" vertical sm={12} >
                {this.props.data.get('links', new List()).size ?
                  <div>
                    <ProductsViewer links={this.props.data.get('links')} />
                    <input
                      name="product" value={this.props.product}
                      style={{ display: 'none' }}
                      onChange={() => ({})}
                    />
                  </div>
                  :
                  <RequiredFormControl
                    component={RefPicker}
                    noAddButton
                    dict="product"
                    dictType="complex"
                    name="linkedProducts"
                    onChangeFunc={val =>
                      this.props.updateDealField('linkedProducts', val.map(v => v.value))}
                    defaultValue={this.props.data.get('linkedProducts')}
                    multi
                    disabled={this.props.disabled}
                  />
                }
              </Label>
            </Col>

          </Row>
        </Col>
        <Col xs={12}>
          <Row >
            <Col xs={12} className={'transport-edit-total-bl-row'}>
              {this.renderBLInfo()}
            </Col>
            <Col xs={12}>
              <TransportElement data={this.props.data} editForm disabled={this.props.disabled} />
            </Col>
          </Row>
          <Row style={{ padding: '15px' }}>
            <Col md={6}>
              <Row
                className="transport-edit-port-block"
                style={{ marginRight: '-10px' }}
              >
                <Col sm={12}>
                  <Row>
                    <Col md={12}>
                      <img
                        src={loadport}
                        role={'presentation'} className={'small-transport-port-icon'}
                      />
                      <Label
                        label="Loading at" vertical sm={12}
                      >
                        <RefPicker
                          dict="port" name="loadingPort"
                          defaultValue={this.props.data.get('loadingPort')}
                          disabled={this.props.disabled}
                          onChangeFunc={val => this.props.alterPortField('loadingPort',
                            val !== undefined && val !== null ? val.value : val)
                          }
                        />
                      </Label>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={12}>
                      <Label label="Status" vertical sm={12} >
                        <FormControl
                          componentClass="select"
                          placeholder="Select..."
                          name="loadingPortStatus"
                          defaultValue={this.props.data.get('loadingPortStatus')}
                          disabled={this.props.disabled}
                        >
                          {railcarLoadingStatus.entrySeq()
                            .map(vals =>
                              <option key={vals[0]} value={vals[0]}>{vals[1]}</option>,
                            )
                          }
                        </FormControl>
                      </Label>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <Label
                        label="Shipment date" vertical sm={12}

                      >
                        <DateTimePicker
                          format={dateTimePickerFormat}
                          time={false}
                          name="onBoardDate"
                          onChange={(() => this.props.handleFormChanged())}
                          defaultValue={this.props.data.get('onBoardDate')
                            ? new Date(this.props.data.get('onBoardDate'))
                            : null}
                          disabled={this.props.disabled}
                        />
                      </Label>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={12}>
                      <Label
                        label="Comment" vertical sm={12}
                      >
                        <FormTextField
                          name="loadingPortComment"
                          onChangeFunc={(val) =>
                            this.props.alterPortField('loadingPortComment', val)
                          }
                          defaultValue={this.props.data.get('loadingPortComment')}
                          disabled={this.props.disabled}
                        />
                      </Label>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
            <Col md={6}>
              <Row
                className="transport-edit-port-block"
                style={{ marginLeft: '-10px' }}
              >
                <Col sm={12}>
                  <Row>
                    <Col md={12}>
                      <img
                        src={unloadport}
                        role={'presentation'} className={'small-transport-port-icon'}
                      />
                      <Label
                        label="Discharge at" vertical sm={12}

                      >
                        <RefPicker
                          dict="port" name="dischargePort"
                          defaultValue={this.props.data.get('dischargePort')}
                          disabled={this.props.disabled}
                          onChangeFunc={val =>
                            this.props.alterPortField('dischargePort',
                              val !== undefined && val !== null ? val.value : val)}
                        />
                      </Label>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={12}>
                      <Label
                        label="Comment" vertical sm={12}
                      >
                        <FormTextField
                          name="dischargePortComment"
                          onChangeFunc={(val) =>
                            this.props.alterPortField('dischargePortComment', val)
                          }
                          defaultValue={this.props.data.get('dischargePortComment')}
                          disabled={this.props.disabled}
                        />
                      </Label>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </div>);
  }
}
TruckEdit.propTypes = {
  data: React.PropTypes.object,
  openModal: React.PropTypes.func,
  hidden: React.PropTypes.bool,
  disabled: React.PropTypes.bool,
  cancel: React.PropTypes.func,
  onFromSubmitHandler: React.PropTypes.func,
  product: React.PropTypes.oneOfType([React.PropTypes.number, React.PropTypes.string]),
  updateProduct: React.PropTypes.func,
  currentUser: React.PropTypes.number,
  updateDealField: React.PropTypes.func,
  updateDealFields: React.PropTypes.func,
  isNew: React.PropTypes.bool,
  alterPortField: React.PropTypes.func,
  onVesselNameChange: React.PropTypes.func,
  onArchive: React.PropTypes.func,
  locked: React.PropTypes.bool,
  allowResponsiblesEdit: React.PropTypes.bool,
};

export default connect(
  state => ({
    currentUser: Number(state.getIn(['session', 'id'])),
  }),
  dispatch => ({
    updateDealField(field, value) {
      updateDealField(dispatch, 'transport', field, value);
    },
    updateDealFields(map) {
      updateDealFields(dispatch, map);
    },
    alterPortField(portType, id) {
      alterPortField(dispatch, portType, id);
    },
    onVesselNameChange(name) {
      alterVesselname(dispatch, name);
    },
    handleFormChanged() {
      handleFormChanged(dispatch);
    },
  }),
)(TruckEdit);
